/**
 * Formats SQL query string by:
 * 1. Removing extra whitespace
 * 2. Removing line breaks
 * 3. Ensuring consistent spacing around SQL keywords
 * 
 * @param strings Template literal strings
 * @param values Values to interpolate
 * @returns Formatted SQL string
 */
export const formatSql = (strings: TemplateStringsArray, ...values: any[]) => {
    // Combine the strings and values
    let sql = strings.reduce((result, str, i) => {
        return result + str + (values[i] || '');
    }, '');

    return sql
        // Remove extra whitespace and newlines
        .replace(/\s+/g, ' ')
        // Trim leading/trailing whitespace
        .trim();
}; 